export var estilos_informes =
  "p,div,h1{font-family: Arial !important;} " +

  ".hoz table,.hoz td{border:1px solid black;} " +
  "table,tr,td{margin:0;padding:0;} " +

  ".hoz thead td{background:black;color:white;font-weight:bold;border:1px solid black;} " +
  ".hoz td{text-align:center;} " +

  "table.cabecera{border-collapse:collapse;} " +
  ".cabecera tr,.cabecera td{border:1px solid black;} " +
  ".cabecera{width:100%;} " +

  "p,td,th{font-size:14px;} " +

  /* === WORD-SAFE IMAGE LAYOUT === */
".img-table{border-collapse:collapse;table-layout:fixed;} " +
".img-td{vertical-align:top;padding:4px;} " +

".img-box{text-align:center;line-height:100px;overflow:hidden;} " +
".img-box img{width:30px !important;height:auto !important;max-height:200px;vertical-align:middle;display:inline;} " +
"img{width:30px !important; height: auto;} ";
